import React, { useState } from 'react';
import classNames from 'classnames';
import Tooltip from '../../Tooltip/Tooltip/Tooltip.js';
import { sizeOptions } from '../../../../helpers/enums/themes/sizeOptions.js';
import { fontWeightOptions } from '../../../../helpers/enums/themes/fontStyleOptions.js';
import styles from './Pill.scss.js';
import Icon from '../../../Icons/Icons/Icon/Icon.js';

const PillColorOptions = {
  aquaHaze: 'container--aqua-haze',
  gray: 'container--gray',
  grayWithDarkerText: 'container--gray-darker-text',
  redWithBorderRed: 'container--red-all',
  whiteWhithBorderBLue: 'container--white-blue',
  whiteWhithBorderLimedSpruce: 'container--white-limed-spruce',
  yellow: 'container--yellow',
  yellowWithDarkerText: 'container--yellow-darker-text'
};
const Pill = _ref => {
  let {
    children,
    color = 'gray',
    tooltip = false,
    childrenTooltip = [],
    arrow = 'top-left',
    size = sizeOptions.medium,
    fontWeight = fontWeightOptions.roman,
    align = 'left',
    shouldShowCloseButton = false,
    onClose = () => {},
    iconBefore,
    isUppercase = false
  } = _ref;
  const [isCloseIconHover, setIsCloseIconHover] = useState(false);
  const getChildrenTooltip = () => {
    if (childrenTooltip?.length === 1) return childrenTooltip[0];
    return /*#__PURE__*/React.createElement("ul", {
      className: styles['container-tooltip-list']
    }, childrenTooltip?.map(label => /*#__PURE__*/React.createElement("li", {
      key: `pill-tooltip-${label}-key`,
      className: styles['container-tooltip-list-item']
    }, label)));
  };
  const onCloseIconMouseEnter = () => setIsCloseIconHover(true);
  const onCloseIconMouseLeave = () => setIsCloseIconHover(false);
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.container, styles['np-base'], styles[PillColorOptions[color]], styles[size], styles[fontWeight])
  }, !!iconBefore && /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['container-icon-container'], styles['container-icon-container--before'])
  }, iconBefore), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.label, {
      [styles.uppercase]: isUppercase
    })
  }, children), shouldShowCloseButton && /*#__PURE__*/React.createElement("button", {
    className: styles['container-close-button'],
    onClick: onClose,
    onMouseEnter: onCloseIconMouseEnter,
    onMouseLeave: onCloseIconMouseLeave
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['container-close-button-icon']
  }, isCloseIconHover ? /*#__PURE__*/React.createElement(Icon, {
    icon: "system-ui-x-close-darker-xxs"
  }) : /*#__PURE__*/React.createElement(Icon, {
    icon: "system-ui-x-close-dark-xxs"
  }))), tooltip && /*#__PURE__*/React.createElement("span", {
    className: styles['container-tooltip']
  }, /*#__PURE__*/React.createElement(Tooltip, {
    arrow: arrow,
    align: align
  }, getChildrenTooltip())));
};
var Pill$1 = Pill;

export { PillColorOptions, Pill$1 as default };
//# sourceMappingURL=Pill.js.map
